import * as React from 'react';
import { animated } from 'react-spring';

import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

import { WTProvider, useTrack } from '@root/initializers/wt';

import { LandingAbeetProvider } from '@shared/abeet';
import { Header } from '@shared/content/header';

import { Layout } from '@utils/clean';
import { useOnMount } from '@utils/hooks/mount';

import openBoxRealistic from '@images/home/open-box-realistic.png';

const styles = css`
  html,
  body {
    width: 100%;
    height: 100%;
    background: white;
    text-align: center;
    margin: 0;
  }

  * {
    box-sizing: border-box;
  }
`;

const Content = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
`;

const Headline = styled.h3`
  color: ${COLORS.tealDark};
  font-size: clamp(1.5em, 3vw, 2em);
  font-family: Recoleta;
  margin-top: 1vh;
  margin-bottom: 2vh;
  margin-left: 1vh;
  margin-right: 1vh;
`;

const Image = styled(animated.img)`
  ${mq({
    maxHeight: '30vh',
    marginTop: '10vh',
  })}
`;

const Message = styled.p`
  font-size: clamp(1em, 1.65vw, 1.2em);
  width: 50%;
  min-width: 300px;
  text-align: center;
  margin: auto;
  color: ${COLORS.tealDark};

  a {
    color: ${COLORS.tealDark};
    font-weight: bolder;
    text-decoration: none;
    cursor: pointer;
  }
`;

const NotFoundMessage: React.FC = () => {
  const track = useTrack();

  useOnMount(() => {
    track({
      action: 'display',
      objectName: 'not_found_message',
    });
  });

  return (
    <Layout>
      <Global styles={styles} />
      <Content>
        <Header themeName="teal" hidePhone={true} />
        <Image src={openBoxRealistic} />
        <Headline>Sorry! Our blog and all articles have been retired.</Headline>
        <Message>
          Visit <a href="https://www.clutter.com">Clutter.com</a> for more information about
          services, pricing, and more! <br />
        </Message>
      </Content>
    </Layout>
  );
};

const BlogNotFound: React.FC = () => {
  return (
    <WTProvider params={{ pageName: 'not_found' }}>
      <LandingAbeetProvider>
        <NotFoundMessage />
      </LandingAbeetProvider>
    </WTProvider>
  );
};

export { BlogNotFound };
